import style from "./style.scss";

const NoWrap = ({ children }) => <span class={style.noWrap}>{children}</span>;

export default NoWrap;
